module.exports = __webpack_public_path__ + "assets/img/Static_display.49eb986a.svg";